import { RepositoriesService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { repositoriesKeys } from 'app/queries/repositories/repositoriesKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof repositoriesKeys.attachmentPlaybackUrl>>;

export const createFetchRepositoryAttachmentPlaybackUrlQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ attachmentId }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(RepositoriesService.downloadAttachment({ repositoryAttachmentId: attachmentId }), signal),
    );
